import { useEffect, useRef, useState } from 'react'

import { IEntity, INLUDataExample } from '../../../../../stores/nluDataStore'
import Entities from '../../Entities/Entities'
import Message from '../../Message/Message'

import { joinClassNames } from '../../../../../utils/styles'
import styles from './message-section.module.scss'

interface IMessageSectionProps {
    example: INLUDataExample
    examplesRef: React.RefObject<HTMLDivElement>
    allEntities: string[]
    setEntities: (entities: IEntity[]) => void
    isAnyEntityEditing: boolean
    setIsAnyEntityEditing: React.Dispatch<React.SetStateAction<boolean>>
    startEditingCallback?: () => void
    className?: string
}

function MessageSection(props: IMessageSectionProps) {
    const {
        example,
        isAnyEntityEditing,
        setIsAnyEntityEditing,
        examplesRef,
        allEntities,
        setEntities,
        startEditingCallback,
        className,
    } = props
    const { entities } = example

    const messageRef = useRef<HTMLDivElement>(null)

    const [isCurrentEntityEditing, setIsCurrentEntityEditing] = useState(false)
    const [editingEntities, setEditingEntities] = useState<IEntity[]>(
        entities || []
    )

    useEffect(() => {
        setEditingEntities(entities)
    }, [entities])

    useEffect(() => {
        if (!isCurrentEntityEditing) {
            setEditingEntities(entities)
        }
    }, [isCurrentEntityEditing])

    const handleStopEditingEntities = () => {
        setIsAnyEntityEditing(false)
        setIsCurrentEntityEditing(false)
        setEditingEntities(entities)
    }

    const handleStartEditingEntities = (newEntity: IEntity) => {
        startEditingCallback?.()

        if (!isAnyEntityEditing && !isCurrentEntityEditing) {
            setIsAnyEntityEditing(true)
            setIsCurrentEntityEditing(true)
        }

        if (isAnyEntityEditing !== isCurrentEntityEditing) {
            return
        }

        setEditingEntities((prevEditingEntities) => {
            const editingEntities = structuredClone(prevEditingEntities)
            const isEditing = editingEntities.some((entity) =>
                newEntity.tokens.some((child) => entity.tokens.includes(child))
            )

            if (isEditing) {
                return editingEntities
            }

            editingEntities.push(newEntity)

            return editingEntities
        })
    }

    return (
        <div className={joinClassNames(styles.messageSection, className)}>
            {isCurrentEntityEditing && (
                <Entities
                    example={example}
                    editingEntities={editingEntities}
                    handleStopEditingEntities={handleStopEditingEntities}
                    setEditingEntities={setEditingEntities}
                    examplesRef={examplesRef}
                    messageRef={messageRef}
                    allEntities={allEntities}
                    setEntities={setEntities}
                />
            )}
            <Message
                example={example}
                handleStartEditingEntities={handleStartEditingEntities}
                editingEntities={editingEntities}
                examplesRef={examplesRef}
                messageRef={messageRef}
                allEntities={allEntities}
            />
        </div>
    )
}

export default MessageSection
